import wretchAdapter from '@/shared/api/adapters/wretch';

export default wretchAdapter(CONFIG.MARKETING_LINKS.BACKEND_ROOT_URL);
